import { logger } from '../utils/logger';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { activar, findAll, get, remove, save, update } from "../services/Service";

import { EmpresaGestora, EmpresaGestoraFiltro } from "../types/EmpresaGestora";
import { Instalacion } from "../types/Instalacion";
import { TrabajoEmpresa } from "../types/TrabajoEmpresa";
import {
    addEmpresaGestora,
    loadDataEmpresaGestora,
    loadListEmpresaGestora,
    loadListInstalacion,
    loadListTiposTrabajo,
    loadingError,
    visibleError,
    setGuardado,
    loadDataFiltro,
    empresaGestoraInitial,
    empresaGestoraFiltroInitial,
} from "../context/EmpresaGestora/EmpresaGestoraReducer";
import api from "../api/api";

export const useEmpresaGestora = () => {
    const BASE_URL = 'empresasGestoras';
    const { loading, empresaGestoraSelected, empresaGestoraList, errors, error, guardado, instalacionList, tiposTrabajoList, filtro } = useSelector(
        (state: RootState) => state.empresaGestora
    );

    const dispatch = useDispatch();

    const buscarEmpresasGestoras = async (filtroEmpresaGestora: EmpresaGestoraFiltro) => {
        let url = `${BASE_URL}/buscar?razonSocial=${filtroEmpresaGestora.razonSocial || ''}`;

        if (filtroEmpresaGestora.idTipoDocPersona !== null && filtroEmpresaGestora.idTipoDocPersona !== '' && filtroEmpresaGestora.idTipoDocPersona !== 0) {
            url = url + `&idTipoDocPersona=${filtroEmpresaGestora.idTipoDocPersona}`
        }
        if (filtroEmpresaGestora.nroIdentificacion !== null && filtroEmpresaGestora.nroIdentificacion !== '') {
            url = url + `&nroIdentificacion=${filtroEmpresaGestora.nroIdentificacion}`
        }
        if (filtroEmpresaGestora.activo !== null && filtroEmpresaGestora.activo !== '') {
            url = url + `&activo=${filtroEmpresaGestora.activo}`
        }

        try {
            const response = await findAll(url);
            dispatch(loadListEmpresaGestora(response.data));
            return response;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const guardarEmpresaGestora = async (empresaGestora: EmpresaGestora) => {
        let response;
        try {
            if (empresaGestora.id === 0) {
                response = await save(BASE_URL, empresaGestora);
                dispatch(addEmpresaGestora(response.data));
            } else {
                response = await update(BASE_URL, empresaGestora);
                dispatch(addEmpresaGestora(response.data));
            }
            return response;
        } catch (error: any) {
            throw error;
        }
    }

    const buscarEmpresaGestora = async (id: string) => {
        try {
            const response = await get(BASE_URL, id)
            dispatch(loadDataEmpresaGestora(response.data));

            return response.data;
        } catch (error) {
            logger.log(error);
        }
    }

    const buscarInstalaciones = async (idEmpresaGestora: number) => {
        try {
            let response = await findAll(`instalaciones/find?idEmpresaGestora=${idEmpresaGestora}`);
            dispatch(loadListInstalacion(response.data));
        } catch (error) {
            logger.log(error);
        }
    }

    const buscarTiposTrabajoAsociados = async (idEmpresaGestora: number) => {
        try {
            let response = await findAll(`trabajosEmpresa/empresaGestora/${idEmpresaGestora}`);
            dispatch(loadListTiposTrabajo(response.data));
        } catch (error) {
            logger.log(error);
        }
    }

    const buscarLogo = async (id: number) => {
        try {
            const response = await api.get(`${BASE_URL}/${id}/logo`, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            logger.log(error);
        }
    }

    const eliminarEmpresaGestora = async (id: string) => {
        try {
            const response = await remove(BASE_URL, id)
            return response;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const activarEmpresaGestora = async (id: string) => {
        try {
            const response = await activar(BASE_URL, id)
            return response;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const handleEmpresaGestoraSelected = (empresaGestora: EmpresaGestora) => {
        dispatch(loadDataEmpresaGestora(empresaGestora))
    }
    const showError = (load: boolean) => {
        dispatch(visibleError(load))
    }
    const setMsgError = (error: string[]) => {
        dispatch(loadingError(error));
    }

    const handleGuardado = (guardado: boolean) => {
        dispatch(setGuardado(guardado))
    }
    const handleInstalacionList = (instalaciones: Instalacion[]) => {
        dispatch(loadListInstalacion(instalaciones));
    }
    const handleTiposTrabajoList = (tiposTrabajo: TrabajoEmpresa[]) => {
        dispatch(loadListTiposTrabajo(tiposTrabajo));
    }
    const handleFiltroEmpresaGestora = (filtroEmpresaGestora: EmpresaGestoraFiltro) => {
        dispatch(loadDataFiltro(filtroEmpresaGestora))
    }
    return {
        buscarEmpresasGestoras,
        guardarEmpresaGestora,
        buscarEmpresaGestora,
        eliminarEmpresaGestora,
        activarEmpresaGestora,
        handleEmpresaGestoraSelected,
        showError,
        setMsgError,
        handleGuardado,
        buscarInstalaciones,
        handleInstalacionList,
        buscarTiposTrabajoAsociados,
        handleTiposTrabajoList,
        handleFiltroEmpresaGestora,
        buscarLogo,
        filtro,
        empresaGestoraInitial,
        empresaGestoraFiltroInitial,
        empresaGestoraList,
        instalacionList,
        tiposTrabajoList,
        empresaGestoraSelected,
        loading,
        errors,
        error,
        guardado
    }
}
